import { inject, Injectable } from '@angular/core';

import { DictionaryItem } from '@hglobal/fin-ui';
import { TranslateService } from '@ngx-translate/core';

import {
  OperationStatus,
  TreasurerOperationType,
  UserOperationType,
} from '../entities';

@Injectable({
  providedIn: 'root',
})
export class DictionariesService {
  readonly #translate = inject(TranslateService);

  readonly #operationTypeValues = Object.values(UserOperationType);
  readonly #treasurerOperationTypeValues = Object.values(
    TreasurerOperationType,
  );
  readonly #operationStatusValues = Object.values(OperationStatus);

  readonly userOperationTypes = this.makeDict(
    this.#operationTypeValues,
    'dictionary.operationTypes',
  );

  readonly treasurerOperationTypes = this.makeDict(
    this.#treasurerOperationTypeValues,
    'dictionary.operationTypes',
  );

  readonly operationStatuses = this.makeDict(
    this.#operationStatusValues,
    'dictionary.operationStatuses',
  );

  readonly operationOngoingStatuses = this.makeDict(
    [OperationStatus.Created, OperationStatus.InProgress],
    'dictionary.operationStatuses',
  );

  readonly operationFinalStatuses = this.makeDict(
    [
      OperationStatus.Completed,
      OperationStatus.Failed,
      OperationStatus.Cancelled,
      OperationStatus.Rejected,
    ],
    'dictionary.operationStatuses',
  );

  readonly categories = this.makeDict(['Fiat'], 'dictionary.categories');

  private makeDict(items: string[], prefix: string): DictionaryItem<string>[] {
    return items.map((id) => {
      const key = this.normalizeKey(id);
      return {
        id,
        name: this.#translate.instant(`${prefix}.${key}`),
      };
    });
  }

  private normalizeKey(id: string): string {
    return id
      .replace(/\s+./g, (match) => match.trim().toUpperCase())
      .replace(/^./, (c) => c.toLowerCase());
  }
}
